<template>
    <div class="layout-px-spacing">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active" aria-current="page">
                                    <span>Add Violator's Details</span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">
            <div class="col-xl-10 col-lg-10 col-md-12 col-12 layout-spacing">
                <div class="panel br-4">
                    <div class="panel-body">
                        <router-link to="/violator/view">
                            <button type="button" class="btn btn-danger mb-2 me-2"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-arrow-left">
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>
                                Back to Violators
                            </button>
                        </router-link>
                        <h6>Add your Violator's Details here...</h6>
                        <!-- <p class="mb-0 mt-3">Add your Violation Details here...</p> -->

                        <!-- Form -->
                        <form @submit.prevent="submitForm">
                            <div class="column">
                                <div class="col-md-12">
                                    <div class="mb-4">
                                        <label class="col-form-label" for="violator_name">Violator's Name</label>
                                        <div>
                                            <input v-model="employee.name" type="text" id="name" class="form-control"
                                                placeholder="Required" required />
                                        </div>
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="position">Position</label>
                                        <div>
                                            <input v-model="employee.position" type="text" id="position"
                                                class="form-control" placeholder="Required" required />
                                        </div>
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="phone">Phone Number</label>
                                        <div>
                                            <input v-model="employee.phone" type="string" id="phone"
                                                class="form-control" placeholder="Optional" />
                                        </div>
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="email">Email</label>
                                        <div>
                                            <input v-model="employee.email" type="email" id="email" class="form-control"
                                                placeholder="Optional" />
                                        </div>
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        {{ loading ? 'Submitting...' : 'Submit' }}
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.layout-px-spacing {
    min-height: calc(100vh - 170px) !important;
}
</style>

<script setup>
import { useMeta } from "/src/composables/use-meta";
import { ref } from 'vue';
import axios from 'axios';
import { BASE_URL } from '/src/Config/config';

useMeta({ title: "Add Violator Details" });

const loading = ref(false);

const employee = ref({
    name: '',
    position: '',
    phone: '',
    email: ''
});

const submitForm = async () => {
    try {
        loading.value = true;

        const response = await axios.post(`${BASE_URL}/employees`, employee.value);

        console.log('Violator added:', response.data); // Debugging / Confirmation

        // Optionally show a success message
        alert('Violator added successfully!');

        // Reset form fields
        employee.value = {
            name: '',
            position: '',
            phone: '',
            email: ''
        };
    } catch (error) {
        console.error('Error adding violator:', error);
        alert('Failed to add violator!');
    } finally {
        loading.value = false;
    }
};
</script>
